import React from 'react'
import { SkeletonBox } from './styled'

const Skeleton = ({ width, height }) => <SkeletonBox height={height} />

export default Skeleton
